export default __webpack_public_path__ + "static/media/Panthers.d6ea0dda.png";